import { Button } from '@repo/shadcn';
import { ColumnDef, Row } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { formatCurrencyInBDT } from '@/utils/currency-formater';

import { Route } from '../../../constants';

export const columns: ColumnDef<any>[] = [
    {
        accessorKey: 'customerName',
        header: () => {
            return <span>Name</span>;
        },
        cell: ({ row }) => (
            <Link
                to={`${Route.WHOLESALE_ORDER_CUSTOMERS}/${row.original.customerId}`}
            >
                <Button
                    type="button"
                    variant={'link'}
                    size={'default'}
                    className="p-0 text-black"
                >
                    {row.getValue('customerName')}
                </Button>
            </Link>
        ),
    },

    {
        accessorKey: 'createdAt',
        header: () => {
            return (
                <div className="flex justify-center">
                    <span className="">Date</span>
                </div>
            );
        },
        cell: ({ row }) => {
            return (
                <div className="text-center">
                    {row.original.createdAt
                        ? new Date(row.original.createdAt).toLocaleString()
                        : 'N/A'}
                </div>
            );
        },
    },

    {
        accessorKey: 'totalItems',
        header: () => {
            return (
                <div className="flex justify-end">
                    <span className="text-right">Total Items</span>
                </div>
            );
        },
        cell: ({ row }) => (
            <div className="text-right font-medium">
                {row.getValue('totalItems')}
            </div>
        ),
    },

    {
        accessorKey: 'totalPrice',
        header: () => {
            return (
                <div className="flex justify-end">
                    <span className="text-right">Total Price</span>
                </div>
            );
        },
        cell: ({ row }) => (
            <div className="text-right font-medium">
                {formatCurrencyInBDT(row.getValue('totalPrice'))}
            </div>
        ),
    },

    {
        accessorKey: 'description',
        header: () => <div className="text-right">Actions</div>,
        id: 'actions',
        enableHiding: false,
        cell: ({ row }) => {
            return <RowActionColumn row={row} />;
        },
    },
];

const RowActionColumn = ({ row: _ }: { row: Row<any> }) => {
    return (
        <div className="flex items-center justify-end gap-1">
            <Link
                to={`${Route.WHOLESALE_ORDER_REQUESTS}/${_.original.id}`}
                className="text-blue-600 hover:underline"
            >
                <Button
                    type="button"
                    variant={'link'}
                    size={'default'}
                    className="p-0 text-black"
                >
                    View Details
                </Button>
            </Link>

            {/* Action */}
            {/* <Button
        variant="link"
        onClick={() =>
          dispatch(
            openModal({
              content: 'Edit Generic',
              data: row.original,
            }),
          )
        }
        className=" flex gap-1 items-center bg-green-50 text-green-800 border-green-700/20 h-fit"
      >
        <BiEdit size={16} />
      </Button>
      <Button
        variant="link"
        onClick={() =>
          window.confirm('Are you sure you want to delete this generic?') &&
          deleteGeneric(row.original.id)
        }
        // onClick={() => deleteBrand(row.original.id)}
        className=" flex gap-1 items-center  text-red-800 border-red-700/20 h-fit"
      >
        <TbTrash className="h-5 w-5 text-red-800 group-hover:text-red-500" />
      </Button> */}
        </div>
    );
};
